module.exports = __webpack_public_path__ + "static/img/zhongzhongka20.ba00cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka20.png
// module id = eXYY
// module chunks = 16